var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1:916)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.99833C11.56 6.99833 11.2 6.61833 11.2 6.14333C11.2 5.66833 11.56 5.28833 12 5.28833H12.8C14.57 5.28833 16 6.81888 16 8.71888V15.58C16 17.4694 14.57 19.0106 12.8 19.0106H3.2C1.43 19 0 17.4694 0 15.5694V8.70833C0 6.80833 1.43 5.27777 3.2 5.27777H4C4.44 5.27777 4.8 5.65777 4.8 6.13277C4.8 6.60777 4.44 6.98777 4 6.98777H3.2C2.32 6.98777 1.6 7.75833 1.6 8.69777V15.5589C1.6 16.5089 2.32 17.2689 3.2 17.2689H12.8C13.68 17.2689 14.4 16.4983 14.4 15.5589V8.69777C14.4 7.74777 13.68 6.98777 12.8 6.98777H12V6.99833Z",
    fill: "#80808F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46994 0.242731C7.75994 -0.0844911 8.23994 -0.0844911 8.52994 0.242731L10.7799 2.73384C11.0699 3.06106 11.0699 3.57829 10.7799 3.90551C10.4899 4.23273 10.0099 4.23273 9.71994 3.90551L8.74994 2.82884V10.8194C8.74994 11.2205 8.46994 11.5477 8.09994 11.6005L7.99994 11.6111C7.58994 11.6111 7.24994 11.2522 7.24994 10.8194V2.82884L6.27994 3.90551C6.00994 4.20106 5.59994 4.22218 5.29994 3.9794L5.21994 3.90551C4.92994 3.57829 4.92994 3.06106 5.21994 2.73384L7.46994 0.242731Z",
    fill: "#80808F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1:916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 19,
    fill: "white"
  })))));
};
export default SvgShare;